import { useCallback, useEffect, useState } from 'react'
import { rpc } from '../api/rpc'
import type { ModelList } from '../api/types'

export function useModels() {
  const [models, setModels] = useState<ModelList | null>(null)
  const reload = useCallback(async () => setModels(await rpc.call<ModelList>('models.list')), [])
  useEffect(() => { void reload().catch(() => undefined) }, [reload])
  return { models, reload, setModels }
}
